import { NavLink, useRoutes } from "react-router-dom";
import "./App.css";
import routes from "./routes/index";
import a from "./assets/logo.png";
import React, { useState, useEffect } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Menu, Modal, Tabs, Checkbox, Form, Input } from 'antd';
// let BMap = window.BMap;
function App() {
  const [login,uselogin] = useState("登录/注册")
  const element = useRoutes(routes);
  const activeClassName = ({ isActive }) =>
  isActive ? "column colors" : "column";
  const [current, setCurrent] = useState('mail1');
  const token = localStorage.getItem('zw_token')
  console.log(token,'token')
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };
  // const onChange = (key) => {
  //   console.log(key);
  // };
  // const onFinish = (values) => {
  //   console.log('Success:', values);
  // };
  // const onFinishFailed = (errorInfo) => {
  //   console.log('Failed:', errorInfo);
  // };
  const items = [
    {
      label: (<NavLink to="/index" className={activeClassName}>
        首页
      </NavLink>),
      key: 'mail1',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/about" className={activeClassName}>
        企业文化
      </NavLink>),
      key: 'mail2',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/news" className={activeClassName}>
        新闻动态
      </NavLink>),
      key: 'mail3',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/solution" className={activeClassName}>
        平台介绍
      </NavLink>),
      key: 'mail4',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/culture" className={activeClassName}>
        公司党建
      </NavLink>),
      key: 'mail8',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/contact" className={activeClassName}>
        联系我们
      </NavLink>),
      key: 'mail5',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/announcement" className={activeClassName}>
        获得证书
      </NavLink>),
      key: 'mail6',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/Login" className={activeClassName}>
         <Button type="primary">{login}</Button>
      </NavLink>),
      key: 'mail7',
      // icon: <MailOutlined />,
    },
  ];
  const item = [
    {
      label: (<NavLink to="/index" className={activeClassName}>
        首页
      </NavLink>),
      key: 'mail1',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/about" className={activeClassName}>
        企业文化
      </NavLink>),
      key: 'mail2',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/news" className={activeClassName}>
        新闻动态
      </NavLink>),
      key: 'mail3',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/solution" className={activeClassName}>
        平台介绍
      </NavLink>),
      key: 'mail4',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/contact" className={activeClassName}>
        联系我们
      </NavLink>),
      key: 'mail5',
      // icon: <MailOutlined />,
    },
    {
      label: (<NavLink to="/announcement" className={activeClassName}>
        获得证书
      </NavLink>),
      key: 'mail6',
      // icon: <MailOutlined />,
    }
  ];
  const onClick = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
  };
  return (
    <div className="container" style={{ clear: "both" }}>
      <div>
        <div className="top">
          <img className="logo" src={a} alt="" />
          {token==null?<Menu itemMarginInline="8" onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items}/> : <Menu itemMarginInline="8" onClick={onClick} selectedKeys={[current]} mode="horizontal" items={item}/>}
        </div>
      </div>
      <div className="main">
        {element}
        <div className="clear"></div>
      </div>

      <div className="footer">
        <p>©2023- 杭州中网智慧科技有限公司版权所有</p>
        <p>
          <a
            href="https://beian.miit.gov.cn"
            style={{ color: "white" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            浙ICP备2023011396号
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
